import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgParsian = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#D43E33'
      fillRule='evenodd'
      d='M21.077 3.689c.05.025.247.14.296.167 1.02.545 1.619 1.33 1.627 2.456v17.68L14.812 24l-2.028-.007V16.71c-.007-2.624.316-4.848 1.123-6.49 0 0 .837.86 1.176 2.398q.487-1.34 1.854-2.12c.602 3.508-.807 5.22-3.13 6.117v6.435l8.188-.008V7.21c-.009-1.186-.671-1.992-1.78-2.538zM3.923 3.689c-.05.025-.247.14-.297.167C2.61 4.401 2.008 5.186 2 6.312v17.68l8.188.008 2.028-.007V16.71c.007-2.624-.317-4.848-1.123-6.49 0 0-.837.86-1.176 2.398q-.487-1.34-1.855-2.12c-.6 3.508.808 5.22 3.131 6.117v6.435l-8.189-.008V7.21c.01-1.186.672-1.992 1.78-2.538z'
      clipRule='evenodd'
    />
    <path
      fill='#1A1A18'
      fillRule='evenodd'
      d='M22.103 2.17c-2.278 1.878-3.766 4.194-3.997 7.371-.09 1.25-.316 1.985-.628 2.615l-.179-2.455c-.446.148-.85.402-1.175.742-.323-.722-1.133-.875-2.274-.64 1.86-4.63 4.554-7.309 8.253-7.634'
      clipRule='evenodd'
    />
    <path
      fill='#D43E33'
      fillRule='evenodd'
      d='M14.845 6.67a9.6 9.6 0 0 1 1.93-2.292c-.328-1.172-.476-2.417-.524-3.7-.505 1.515-1.28 2.78-2.455 3.683a8.7 8.7 0 0 0 1.05 2.31'
      clipRule='evenodd'
    />
    <path
      fill='#1A1A18'
      fillRule='evenodd'
      d='M17.174 4.02c-.358-.877-.552-1.807-.386-2.859.234-1.194 3.752-.291 2.622 1.103zM13.63 3.895a7.1 7.1 0 0 0 1.902-2.775c.432-1.165-2.578-1.682-2.59-.252a6.7 6.7 0 0 0 .687 3.027M2.72 2.17C4.996 4.047 6.485 6.363 6.715 9.54c.09 1.25.316 1.985.629 2.615l.178-2.455a2.9 2.9 0 0 1 1.176.742c.324-.722 1.132-.875 2.274-.64-1.86-4.63-4.553-7.309-8.252-7.634'
      clipRule='evenodd'
    />
    <path
      fill='#D43E33'
      fillRule='evenodd'
      d='M9.975 6.67a9.6 9.6 0 0 0-1.93-2.292c.327-1.172.476-2.417.524-3.7.504 1.515 1.28 2.78 2.45 3.683a8.7 8.7 0 0 1-1.044 2.31'
      clipRule='evenodd'
    />
    <path
      fill='#1A1A18'
      fillRule='evenodd'
      d='M7.648 4.02c.358-.877.552-1.807.385-2.859C7.8-.033 4.282.87 5.411 2.264zM11.193 3.895A7.1 7.1 0 0 1 9.289 1.12C8.857-.045 11.868-.562 11.88.868a6.7 6.7 0 0 1-.686 3.027M12.382 9.52c.438.17.715.376.9.62.32-1.045.74-2.056 1.257-3.018-1.087-1.965-1.691-4.092-2.161-6.265-.469 2.173-1.073 4.298-2.16 6.265.518.962.94 1.973 1.26 3.018.193-.245.467-.45.904-.62'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgParsian)
export default ForwardRef
